const peopleData = {
    faculty: [
        {
            name: 'Nandita Vijaykumar',
            title: 'Assistant Professor',
            imgName: 'nandita_v.jpeg',
            link: 'https://www.cs.toronto.edu/~nandita/',
        },
    ],
    grad: [
        {
            name: 'Ruofan Liang',
            title: 'Ph.D. Student',
            imgName: 'ruofan_l.png',
            link: 'https://nexuslrf.github.io/',
        },
        {
            name: 'Sankeerth Durvasula',
            title: 'Ph.D. Student',
            imgName: 'sankeerth_d.jpeg',
            link: 'https://www.cs.toronto.edu/~sankeerth/',
        },
        {
            name: 'Gavin Guan',
            title: 'Ph.D. Student',
            imgName: 'gavin_g.jpg',
            link: 'https://gavinguan95.github.io/',
        },
        {
            name: 'Pawan Kumar Sanjaya',
            title: 'Ph.D. Student',
            imgName: 'pawan_s.jpg',
            link: 'https://pawks.github.io/',
        },
        {
            name: 'Adrian Zhao',
            title: 'Ph.D. Student',
            imgName: 'adrian_z.jpg',
            link: 'https://www.cs.toronto.edu/~adrianz/',
        },
        {
            name: 'Andreas Burger',
            title: 'Ph.D. Student',
            imgName: 'andreas_b.jpg',
            link: 'https://www.andreas-burger.com/',
        },
        {
            name: 'Mohammadreza Mofayezi',
            title: 'Ph.D. Student',
            imgName: 'mohammadreza_m.jpg',
            link: 'https://mofayezi.github.io/'
        },
        {
            name: 'Steve Rhyner',
            title: 'Ph.D. Student',
            imgName: 'steve_r.jpg',
            link: 'emailto:rhyners@cs.toronto.edu'
        },
        {
            name: 'Zhijie Wu',
            title: 'Ph.D. Student',
            imgName: 'zhijie_w.jpg',
            link: 'https://zhijiew94.github.io/'
        },
        {
            name: 'Qianfan Shen',
            title: 'Ph.D. Student',
            imgName: 'Qianfan_s.jpg',
            link: 'https://www.linkedin.com/in/qianfan-shen-40376a287/'
        },
        {
            name: 'Harman Singh Bagga',
            title: 'Ph.D. Student',
            imgName: 'Harman_s.jpg',
            link: 'mailto:harman.bagga@mail.utoronto.ca'
        },
        {
            name: 'Filip Grigorov',
            title: 'MSc Student',
            imgName: 'filip_g.jpg',
            link: 'https://filipgrigorov-portfolio.github.io/',
        },
        {
            name: 'Stefan de Lasa',
            title: 'MASc Student',
            imgName: 'stefan_l.jpg',
            link: 'https://www.linkedin.com/in/stefandelasa/'
        }
    ],
    interns: [
        {
            name: 'Olivia Yan',
            title: 'Undergraduate Intern',
            imgName: 'Olivia_y.png',
            link: 'https://www.linkedin.com/in/olivia-yan-a881ab263/'
        },
        {
            name: 'Yunzhe Qiao',
            title: 'Undergraduate Intern',
            imgName: 'Yunzhe_q.png',
            link: 'mailto:yunz@cs.toronto.edu'
        },
        {
            name: 'Cayden Wong',
            title: 'Undergraduate Intern',
            imgName: 'Cayden_w.jpeg',
            link: 'https://www.linkedin.com/in/cayden-wong/'
        },
        {
            name: 'Dorothy Zheng',
            title: 'Undergraduate Intern',
            imgName: 'dorothy_z.jpg',
            link: 'https://www.linkedin.com/in/dorothy-zheng07/'
        },
        {
            name: 'Ananya Chittlangia',
            title: 'Intern',
            imgName: 'ananya_c.jpg',
            link: 'https://www.linkedin.com/in/ananya-chittlangia/'
        },
        {
            name: 'Aditya Rajeev',
            title: 'Intern',
            imgName: 'aditya_r.jpeg',
            link: 'https://www.linkedin.com/in/adityarajeev/'
        },
        {
            name: 'Ricky Pramanick',
            title: 'Intern',
            imgName: 'ricky_p.jpg',
            link: 'https://www.linkedin.com/in/rickygrosvenorpramanick'
        },
        {
            name: 'Leo Cheng',
            title: 'Intern',
            imgName: 'leo_c.jpg',
            link: 'https://www.linkedin.com/in/leo-kaixuan-cheng-a4912a322/'
        },
        {
            name: 'Kevin Li',
            title: 'Intern',
            imgName: 'placeholder.png',
            link: 'mailto:lkevin.li@mail.utoronto.ca'
        },
    ],
    others: [
        {
            name: 'Christina Giannoula',
            title: 'Incoming Faculty at Max Planck Institute for Software Systems',
            imgName: 'Christina.jpg',
            link: 'https://cgiannoula.github.io/',
        },
        {
            name: 'Konstantinos Kanellopolous',
            title: 'Ph.D. Student at ETH Zürich',
            imgName: 'konstantinos_k.jpeg',
            link: 'https://konkanello.github.io/#',
        },
        {
            name: 'Nika Mansouri Ghiasi',
            title: 'Ph.D. Student at ETH Zürich',
            imgName: 'nika_g.jpeg',
            link: 'https://www.linkedin.com/in/nika-mansouri-ghiasi-4b521ba2/?originalSubdomain=ir',
        },
        {
            name: 'Junehyung Kim',
            title: 'Researcher at LG Electronics',
            imgName: 'junehyung_k.jpg',
            link: 'mailto:junehyung.kim@utoronto.ca'
        },
        {
            name: 'Changwoo Cho',
            title: 'Researcher at LG Electronics',
            imgName: 'changwoo_c.jpg',
            link: 'mailto:chocwjc@cs.toronto.edu'
        },
        {
            name: 'Hoyoun Lee',
            title: 'Researcher at LG Electronics',
            imgName: 'hoyoun_l.png',
            link: 'mailto:electlla@cs.toronto.edu'
        },
        {
            name: 'Lovre Antonio Budimir',
            title: 'Visiting PhD student from the University of Zagreb',
            imgName: 'lovre_b.jpg',
            link: 'https://www.linkedin.com/in/lovre-budimir-lab17'
        },
        {
            name: 'Riya Varia',
            title: 'High School Intern',
            imgName: 'Riya_v.png',
            link: 'mailto:riyavaria@cs.toronto.edu/'
        }
        
    ],
    grad_alumni: [
        {
            name: 'Jimmy Lin',
            title: 'Graduated MSc',
            link: '',
        },
        {
            name: 'Maryam Haghifam',
            title: 'Graduated MSc',
            imgName: 'maryam_h.jpg',
            link: 'https://www.linkedin.com/in/maryamhaghifam-92b64a78/',
        },
        {
            name: 'Aida Ebrahimi',
            title: 'Graduated MSc',
            link: '',
        },
        {
            name: 'Fan Chen',
            title: 'Graduated MScAC',
            imgName: 'fan_c.jpg',
            link: 'https://www.linkedin.com/in/fan-chen-680ba9158/',
        },
        {
            name: 'Preet Vimalkumar',
            title: 'Graduated MScAC',
            imgName: 'preet_v.jpg',
            link: 'https://www.linkedin.com/in/preetviradiya/',
        },
        {
            name: 'Cordell Blanchard',
            title: 'Graduated MScAC',
            imgName: 'cordell_b.jpg',
            link: 'https://www.linkedin.com/in/cordell-blanchard',
        },
        {
            name: 'Sruthi Srinivasan',
            title: 'Graduated MScAC',
            imgName: 'sruthi_s.jpg',
            link: 'https://www.linkedin.com/in/sruthi-srinivasan/',
        },
        {
            name: 'Lakshya Gupta',
            title: 'Graduated MScAC',
            imgName: 'lakshya_g.jpg',
            link: 'https://www.linkedin.com/in/lakshyaadm/',
        },
        {
            name: 'Paanugoban Kugathasan',
            title: 'Graduated MScAC',
            imgName: 'paan_k.jpg',
            link: 'https://www.linkedin.com/in/paan-kugathasan',
        },
        {
            name: 'B. Govind Sudarshan',
            title: 'Graduated MScAC',
            imgName: 'govind_s.jpg',
            link: 'https://www.linkedin.com/in/govind-sudarshan',
        },

    ],
    researcher_alumni: [
        {
            name: 'Hyunsoo Kim',
            title: 'Researcher at LG Electronics',
            imgName: 'placeholder.png',
            link: 'https://www.linkedin.com/in/hyunsoo-kim-27030a17/'
        }
    ],
    intern_alumni: [
        {
            name: 'Hongyi Sun',
            title: 'Intern',
            link: '',
        },
        {
            name: 'Haoda Li',
            title: 'Intern',
            link: '',
        },
        {
            name: 'Jenny Xu',
            title: 'Intern',
            link: '',
        },
        {
            name: 'Jonathon Tang',
            title: 'Intern',
            link: '',
        },
        {
            name: 'Kailong Huang',
            title: 'Intern',
            link: '',
        },
        {
            name: 'Yingke Wang',
            title: 'Intern',
            link: '',
        },
        {
            name: 'Yuchong Zhang',
            title: 'Intern',
            link: '',
        },
        {
            name: 'Zhonghan Chen',
            title: 'Intern',
            imgName: 'zhonghan_c.jpg',
            link: '',
        },
        {
            name: 'Shaoxuan Zheng',
            title: 'Intern',
            imgName: 'shaoxuan_z.png',
            link: '',
        },
        {
            name: 'Huiting Chen',
            title: 'Intern',
            imgName: 'huiting_c.jpg',
            link: '',
        },
        {
            name: 'Jiahao Zhang',
            title: 'Intern',
            imgName: 'jiahao_z.jpg',
            link: 'https://www.linkedin.com/in/jiahao-zhang-4988ba230/',
        },
        {
            name: 'Raymond Kigaru',
            title: 'Intern',
            imgName: 'raymond_k.png',
            link: '',
        },
        {
            name: 'Kevin Deng',
            title: 'Intern',
            imgName: 'Kevin-Deng.jpeg',
            link: 'https://www.linkedin.com/in/haoze-kevin-deng-95969b205/',
        },
        {
            name: 'Pooria Poorsavi Tehrani',
            title: 'Intern',
            imgName: 'pooria_t.jpg',
            link: 'https://ppt-productions.com/',
        },
        {
            name: 'Sung Ha',
            title: 'Intern',
            imgName: '',
            link: '',
        },
        {
            name: 'Ankur Verma',
            title: 'Intern',
            imgName: '',
            link: '',
        },
        {
            name: 'Dev Agarwal',
            title: 'Intern',
            imgName: '',
            link: '',
        },
        {
            name: 'Shorya Kumar',
            title: 'Intern',
            imgName: '',
            link: '',
        },
        {
            name: 'Edward Li',
            title: 'Undergraduate Intern',
            imgName: 'Edward-Li.jpg',
            link: 'https://ppt-productions.com/',
        },
        {
            name: 'Andrew D\'Amario',
            title: 'Undergraduate Intern',
            imgName: 'andrew_da.png',
            link: 'https://github.com/andrewaclear',
        },
        {
            name: 'Louis Zhang',
            title: 'Undergraduate Intern',
            imgName: 'louis_z.jpg',
            link: 'https://github.com/AX-I',
        },
        {
            name: 'Kermit Zhao',
            title: 'MScAC Student',
            imgName: 'kermit_z.png',
            link: 'https://www.linkedin.com/in/ke-kermit-zhao-153848184',
        },
        {
            name: 'Zichuan Guan',
            title: 'MScAC Student',
            imgName: 'zichuan_g.png',
            link: 'https://www.linkedin.com/in/zichuan-guan/',
        },
        {
            name: 'Benjamin Correia',
            title: 'MScAC Student',
            imgName: 'placeholder.png',
            link: 'mailto:ben@cs.toronto.edu',
        },
        {
            name: 'Ariel Chouminov',
            title: 'Undergraduate Intern',
            imgName: 'ariel_c.jpeg',
            link: 'https://www.linkedin.com/in/arielchouminov/',
        },
        {
            name: 'Devan Srinivasan',
            title: 'Undergraduate Intern',
            imgName: 'devan_s.png',
            link: 'https://mrmackamoo.ca/',
        },
        {
            name: 'Hanrui Fan',
            title: 'Undergraduate Intern',
            imgName: 'hanrui_f.jpg',
            link: 'https://www.linkedin.com/in/hanrui-fan-jerry',
        },
        {
            name: 'Kaiwen Zheng',
            title: 'Undergraduate Intern',
            imgName: 'kaiwen_z.jpeg',
            link: 'https://www.linkedin.com/in/kaiwen-zheng-289182202/',
        },
        {
            name: 'Mohannad Shehata',
            title: 'Undergraduate Intern',
            imgName: 'mohannad_s.jpg',
            link: 'https://www.linkedin.com/in/mohannad-shehata',
        },
        {
            name: 'Sam Prokopchuk',
            title: 'Undergraduate Intern',
            imgName: 'sam_p.jpeg',
            link: 'https://www.linkedin.com/in/sam-prokopchuk-1908b21a0/',
        },
        {
            name: 'Richard Huang',
            title: 'Undergraduate Intern',
            imgName: 'xiaorui_h.jpeg',
            link: 'https://www.linkedin.com/in/xiaorui-richard-huang/',
        },
        {
            name: 'Mariia Shpir',
            title: 'MITACS Intern',
            imgName: '',
            link: '',
        },
        {
            name: 'Sumit Laddha',
            title: 'MITACS Intern',
            imgName: '',
            link: '',
        },
        {
            name: 'Yuchen Chen',
            title: 'MScAC Student',
            imgName: 'yuchen_c.png',
            link: 'https://www.linkedin.com/in/yuchen-chen-yc',
        },
        {
            name: 'Sumant Bagri',
            title: 'MScAC Student',
            imgName: 'sumant_b.jpg',
            link: 'https://www.linkedin.com/in/sumant-bagri-6aa973100',
        },
        {
            name: 'Yuxuan Zhang',
            title: 'MScAC Student',
            imgName: 'Yuxuan.jpeg',
            link: 'https://www.cs.toronto.edu/~yuxuan/',
        },
        {
            name: 'Samarth Mathur',
            title: 'Research Intern',
            imgName: 'samarth_m.jpg',
            link: 'https://www.linkedin.com/in/samarth-mathur-a8813b174',
        },
        {
            name: 'Sannat Bhasin',
            title: 'Undergraduate Intern',
            imgName: 'sannat_b.jpeg',
            link: 'https://www.linkedin.com/in/sannatbhasin/',
        },
        {
            name: 'Chunlin Li',
            title: 'Intern',
            imgName: 'chunlin_l.jpg',
            link: 'https://www.linkedin.com/in/chunlinli11235/',
        },
        {
            name: 'Sharanshangar Muhunthan',
            title: 'Undergraduate Intern',
            imgName: 'sharanshangar_m.jpeg',
            link: 'https://shangar.ddns.net/',
        },
        {
            name: 'Nikhil Sreekumar',
            title: 'Intern',
            imgName: 'nikhil_s.jpg',
            link: 'https://www.linkedin.com/in/nikhil-sreekumar-a948481a6/',
        },
        {
            name: 'Qingyuan Wu',
            title: 'Intern',
            imgName: 'qingyuan_w.jpg',
            link: 'https://www.linkedin.com/in/qingyuan-wu/',
        },
        {
            name: 'Alec Dewulf',
            title: 'Undergraduate Intern',
            imgName: 'alec_d.png',
            link: 'https://www.alecdewulf.com/',
        },
        {
            name: 'Harshit Gupta',
            title: 'Undergraduate Intern',
            imgName: 'placeholder.png',
            link: 'https://www.linkedin.com/in/harshit-gupta-0947571b2/',
        },
        {
            name: 'Qingyuan Wu',
            title: 'Intern',
            imgName: 'qingyuan_w.jpg',
            link: 'https://www.linkedin.com/in/qingyuan-wu/',
        },
        {
            name: 'Margaret Lair',
            title: 'Intern',
            imgName: 'margaret_l.jpeg',
            link: 'https://www.linkedin.com/in/margaret-lair-aa33a7200/'
        },
        {
            name: 'Daniel Kwan',
            title: 'Undergraduate Intern',
            imgName: 'daniel_k.png',
            link: 'https://www.linkedin.com/in/danielwtkwan',
        },
        {
            name: 'Dorsa Molaverdikhani',
            title: 'Intern',
            imgName: 'dorsa_m.jpg',
            link: 'https://www.linkedin.com/in/dorsa-molaverdikhani/',
        },
        {
            name: 'Jeanine Ohene-Agyei',
            title: 'Intern',
            imgName: 'jeanine_o.jpg',
            link: 'https://www.linkedin.com/in/jeanine-ohene-agyei-8a7bb0239/',
        },
        {
            name: 'Peng Du',
            title: 'Intern',
            imgName: 'peng_d.jpg',
            link: 'https://www.linkedin.com/in/vim-du/',
        },
        {
            name: 'Olivia Yan',
            title: 'Intern',
            imgName: 'olivia_y.jpg',
            link: 'https://www.linkedin.com/in/olivia-yan-a881ab263/',
        },
        {
            name: 'Katia Brechko',
            title: 'Intern',
            imgName: 'katia_b.jpg',
            link: 'https://www.linkedin.com/in/ekaterina-brechko-589651247/'
        },
        {
            name: 'Yifei Zhang',
            title: 'Intern',
            imgName: 'placeholder.png',
            link: 'mailto:yifeiizhang@cs.toronto.edu',
        },
        {
            name: 'Dunyang Ni',
            title: 'Intern',
            imgName: 'placeholder.png',
            link: 'mailto:dunyang.ni@mail.utoronto.ca',
        },
        {
            name: 'Chenjia Hu',
            title: 'Intern',
            imgName: 'placeholder.png',
            link: 'mailto:chenjia.hu@mail.utoronto.ca',
        },
        {
            name: 'Sasha Kovalev',
            title: 'Intern',
            imgName: 'sasha_k.jpg',
            link: 'mailto:s.kovalev@mail.utoronto.ca'
        },
        {
            name: 'Tianlei Pang',
            title: 'Intern',
            imgName: 'placeholder.png',
            link: 'mailto:tianlei.pang@mail.utoronto.ca'
        },
        {
            name: 'Valdy Oktavian',
            title: 'Intern',
            imgName: 'valdy_o.jpg',
            link: 'https://www.linkedin.com/in/valdyoktavian/'
        },
        {
            name: 'Callum Sharrock',
            title: 'Intern',
            imgName: 'callum_s.jpg',
            link: 'https://www.linkedin.com/in/callum-sharrock/'
        },
        {
            name: 'Gabriel Wu',
            title: 'Intern',
            imgName: 'gabriel_w.jpg',
            link: 'https://www.linkedin.com/in/gabriel-wu-2b997b215/',
        },
        {
            name: 'Solemann Mateen',
            title: 'Intern',
            imgName: 'solemann_m.jpg',
            link: 'https://www.linkedin.com/in/solemann-mateen/',
        },
        {
            name: 'Rishit Dagli',
            title: 'Intern',
            imgName: 'rishit_d.jpg',
            link: 'https://www.linkedin.com/in/rishit-dagli/',
        },
        {
            name: 'Anna Li',
            title: 'Intern',
            imgName: 'anna_l.jpg',
            link: 'https://www.linkedin.com/in/anna-li-7191a0294/'
        },
        {
            name: 'Charles Cai',
            title: 'Intern',
            imgName: 'charles_c.jpg',
            link: 'mailto:yihang.cai@mail.utoronto.ca'
        },
        {
            name: 'Pratibha Thakur',
            title: 'Intern',
            imgName: 'pratibha_t.jpg',
            link: 'https://www.linkedin.com/in/thakur-pratibha/'
        },
        {
            name: 'Hansel Jia',
            title: 'Intern',
            imgName: 'placeholder.png',
            link: 'mailto:hansel.jia@mail.utoronto.ca'
        },
        {
            name: 'Jean-Sebastien Dandurand',
            title: 'Undergraduate Intern',
            imgName: 'jean_d.jpg',
            link: 'https://www.linkedin.com/in/jean-sebastien-dandurand-6b822913b/',
        },
        {
            name: 'Pia Donabauer',
            title: 'Intern',
            imgName: 'pia_d.jpg',
            link: 'https://www.linkedin.com/in/pia-donabauer-167543213/'
        },
    ],
    administrator: [
        {
            name: 'Phebe Ma',
            title: 'Lab Administrator',
            imgName: 'phebe_m.jpg',
            link: 'https://www.linkedin.com/in/phebe-ma-82975a287/'
        },
        {
            name: 'Harsh Roghelia',
            title: 'Lab Administrator',
            imgName: 'harsh_r.jpg',
            link: 'https://www.linkedin.com/in/harsh-roghelia-a3a8a588/'
        },

    ],
};

export {peopleData};
